import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { Observable, of } from 'rxjs';
import { catchError, share } from 'rxjs/operators';
import {
  DEFAULT_ERROR_CODE_LOGIN_BFF,
  ERROR_CODE_413
} from '../constants/login-constant';
import {
  loginAndGetDashboardRequest,
  loginAndGetDashboardResponse
} from '../models/login-authentication-screen.interface';
import { LoginDasboardService } from './login-dasboard.service';

@Injectable({
  providedIn: 'root'
})
export class LoginResponseService {
  constructor(
    private loginDasboardService: LoginDasboardService,
    private loggingService: LoggingService
  ) {}

  loginResponse!: Observable<loginAndGetDashboardResponse> | undefined;
  getLoginResponse(
    authenticationConfig: OauthAEMConfig,
    requestPayload: loginAndGetDashboardRequest,
    tokenResponse?: string
  ): Observable<loginAndGetDashboardResponse> {
    if (this.loginResponse) {
      return this.loginResponse;
    } else {
      this.loginResponse = this.loginDasboardService
        .getDashBrdData(authenticationConfig, requestPayload, tokenResponse)
        .pipe(
          catchError((error) => {
            this.loggingService.log(error);
            const errorCode =
              error instanceof HttpErrorResponse && error.status === 413
                ? ERROR_CODE_413
                : DEFAULT_ERROR_CODE_LOGIN_BFF;
            return of({
              errors: [
                {
                  code: errorCode
                }
              ]
            } as loginAndGetDashboardResponse);
          }),
          share()
        );
      return this.loginResponse;
    }
  }
}
